/** When true, uploads must use encrypted JSON POST /attachments (not signed storage PUT). */
export function shouldUseEncryptedChatUpload(input: {
  atRestEncryption?: boolean;
  signErrorMessage?: string | null;
}): boolean {
  if (input.atRestEncryption) {
    return true;
  }
  const msg = input.signErrorMessage?.toLowerCase() ?? "";
  return msg.includes("encryption") && msg.includes("multipart");
}

export async function fileToBase64(file: Blob): Promise<string> {
  const buffer = await file.arrayBuffer();
  const bytes = new Uint8Array(buffer);
  let binary = "";
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  return btoa(binary);
}
